module.exports = __webpack_public_path__ + "static/img/jx-4.ceda385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-4.png
// module id = K1Fo
// module chunks = 0